import fossilImg1 from '@/assets/img/content8/category1/fossilImg1.jpg'
import fossilImg2 from '@/assets/img/content8/category1/fossilImg2.jpg'
import fossilImg3 from '@/assets/img/content8/category1/fossilImg3.jpg'

import fossil2Img1 from '@/assets/img/content8/category2/fossil2Img1.jpg'
import fossil2Img2 from '@/assets/img/content8/category2/fossil2Img2.jpg'

export const btnList = [
  {
    id: 1,
    cnTitle: '马氏燕鸟',
    enTitle: '<em>Yanornis martini</em> Zhou et Zhang, 2001',
  },
  {
    id: 2,
    cnTitle: '甘肃鸟',
    enTitle: '<em>Gansus</em>',
  },
]



export const martiniList = [ // 马氏燕鸟展示化石
  {
    id: 1,
    src: fossilImg2,
    title: '化石：马氏燕鸟',
    enTitle: '',
    details: '',
  },
  {
    id: 2,
    src: fossilImg3,
    title: '化石：马氏燕鸟',
    enTitle: '',
    details: '',
  },
  {
    id: 3,
    src: fossilImg1,
    title: '现代鸟：红嘴鸥',
    enTitle: '<em>Larus ridibundus</em>（Linnaeus, 1766）',
    details: '',
  },
]

export const martiniAnimal = {
  animalType: '马氏燕鸟', // 动物类别
  animalTypeEn: '<em>Yanornis martini</em> Zhou et Zhang, 2001', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '马氏燕鸟与现生红嘴鸥大小近似，喙部细长，强有力的颌骨长有多枚锋利牙齿；后肢强壮，脚趾间可能长有部分蹼膜，类似于现在的鸻科和鹬科鸟类。', // 动物文字介绍
  showList: martiniList,
}

export const gansusList = [ // 甘肃鸟展示化石
  {
    id: 1,
    src: fossil2Img2,
    title: '化石：甄氏甘肃鸟',
    enTitle: '',
    details: '',
  },
  {
    id: 2,
    src: fossil2Img1,
    title: '现代鸟：赤麻鸭',
    enTitle: '<em>Tadorna ferruginea</em>（Pallas, 1764）',
    details: '',
  },
]

export const gansusAnimal = {
  animalType: '甘肃鸟', // 动物类别
  animalTypeEn: '<em>Gansus</em>', // 动物类别英文名字
  categoryInfoImg: '', // 动物特点介绍图片
  categoryTxt: '甄氏甘肃鸟是热河生物群中已知最为进步的今鸟型类，但其上下颌依然保留有细密的牙齿。它们生活在远古湖岸边，很可能属于水陆两栖型鸟类，类似于现在的游禽鸭科。甘肃鸟可能以鱼、昆虫为食，偶尔也吃植物。', // 动物文字介绍
  showList: gansusList,
}